/**
 * Form "Đổi mã" dùng chung (v0.22.3, Q3 = A): màn đổi mã BẮT BUỘC sau khi chủ tiệm đặt hộ (`DangNhap.tsx` → `DoiMa`) và mục
 * "Đổi mã của tôi" trong tờ nhân viên của chính mình (`CauHinh.tsx`). Một đường duy nhất: `POST /v1/auth/doi-ma` — cần mã đang
 * dùng, đếm lượt như đăng nhập, giữ phiên đang dùng và đăng xuất các máy khác.
 */
import { KeyRound } from 'lucide-react'
import { type ReactNode, useState } from 'react'
import { ApiFailure, auth } from './api.ts'
import { T } from './text/vi.ts'
import { ThongBao } from './ui.tsx'

/**
 * G-N2: trong tờ nhân viên đã có nút chính "Lưu nhân viên" → "Đổi mã" là nút PHỤ (viền); màn bắt buộc đổi mã (L1-19) chỉ có
 * form này nên giữ nút chính.
 */
export function lopNutDoiMa(kieu: 'chinh' | 'phu'): string {
  return `nut ${kieu === 'phu' ? 'nut-vien' : 'nut-chinh'} nut-lon nut-rong`
}

export function FormDoiMa({
  onXong,
  dau,
  nhanNut = T.changePinButton,
  kieuNut = 'chinh',
}: {
  /** Đổi mã thành công (máy chủ đã nhận mã mới). */
  onXong: () => void
  /** Phần đầu form (logo + tiêu đề) — chỉ màn bắt buộc đổi mã có. */
  dau?: ReactNode
  nhanNut?: string
  /** `phu` khi form nằm trong tờ đã có nút chính khác. */
  kieuNut?: 'chinh' | 'phu'
}) {
  const [maCu, setMaCu] = useState('')
  const [moi, setMoi] = useState('')
  const [moiLai, setMoiLai] = useState('')
  const [dangGui, setDangGui] = useState(false)
  const [loi, setLoi] = useState<string | null>(null)

  async function gui(e: React.FormEvent) {
    e.preventDefault()
    setLoi(null)
    if (moi !== moiLai) {
      setLoi(T.pinMismatch)
      return
    }
    setDangGui(true)
    try {
      await auth.doiMa(maCu, moi)
      setMaCu('')
      setMoi('')
      setMoiLai('')
      onXong()
    } catch (err) {
      setLoi(err instanceof ApiFailure ? err.messageVi : T.serverFailed)
    } finally {
      setDangGui(false)
    }
  }

  const o = (
    id: string,
    nhan: string,
    giaTri: string,
    doi: (v: string) => void,
    goiY: 'current-password' | 'new-password',
  ) => (
    <div className="truong">
      <label className="nhan" htmlFor={id}>
        {nhan}
      </label>
      <div className="o-nhap-icon">
        <KeyRound size={20} />
        <input
          id={id}
          className="o-nhap"
          type="password"
          value={giaTri}
          onChange={(e) => doi(e.target.value)}
          placeholder={T.pinPlaceholder}
          inputMode="numeric"
          autoComplete={goiY}
          required
        />
      </div>
    </div>
  )

  return (
    <form className="dn-form" onSubmit={gui}>
      {dau}
      {o('ma-cu', T.oldPinLabel, maCu, setMaCu, 'current-password')}
      {o('ma-moi', T.newPinLabel, moi, setMoi, 'new-password')}
      {o('ma-moi-lai', T.newPinAgainLabel, moiLai, setMoiLai, 'new-password')}
      {loi !== null && <ThongBao loai="loi">{loi}</ThongBao>}
      <button type="submit" className={lopNutDoiMa(kieuNut)} disabled={dangGui}>
        {dangGui ? T.loggingIn : nhanNut}
      </button>
    </form>
  )
}
